import { CustomLineItem } from 'shared/types/cart/CustomLineItem';
import { ExtendedLineItem } from 'shared/types/cart/LineItem';

export const calculateSubtotalAmount = (
  lineItems?: ExtendedLineItem[],
  customLineItems?: CustomLineItem[],
) => {
  const lineItemsSubtotal = (lineItems ?? []).reduce((acc, curr) => {
    if (curr.isGift) {
      return acc;
    }

    return (
      acc +
      (curr.price?.centAmount || 0) * (curr.count as number) -
      (curr.taxRate?.includedInPrice
        ? curr.taxed?.taxAmount?.centAmount || 0
        : 0)
    );
  }, 0);

  const mergedCustomLineItemIds = new Set(
    (lineItems ?? []).map((item) => item.customLineItemId).filter(Boolean),
  );

  const customLineItemsSubtotal = (customLineItems ?? [])
    .filter((item) => !mergedCustomLineItemIds.has(item.id))
    .reduce((acc, curr) => {
      return (
        acc +
        (curr.money?.centAmount || 0) * (curr.quantity as number) -
        (curr.taxRate?.includedInPrice
          ? curr.taxed?.taxAmount?.centAmount || 0
          : 0)
      );
    }, 0);

  return lineItemsSubtotal + customLineItemsSubtotal;
};
